import { STEP_NAMES } from './constants';

interface StepProgressProps {
  currentStep: number;
}

export default function StepProgress({ currentStep }: StepProgressProps) {
  const percentage = Math.min(Math.max((currentStep / 4) * 100, 25), 100);
  const currentStepName = STEP_NAMES[currentStep - 1] || '';

  return (
    <div className="w-full mb-8">
      {/* Header labels */}
      <div className="flex items-center justify-between text-xs sm:text-sm font-medium mb-2.5">
        <div className="flex items-center gap-2">
          <span className="text-[#5B3FD0] font-bold">
            الخطوة {currentStep} من 4:
          </span>
          <span className="text-[#2C2C2C] font-semibold">{currentStepName}</span>
        </div>

        {/* Desktop breadcrumb steps */}
        <div className="hidden sm:flex items-center gap-1.5 text-xs">
          {STEP_NAMES.map((name, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isCurrent = stepNumber === currentStep;

            return (
              <span key={name} className="flex items-center gap-1.5">
                <span
                  className={`transition-colors duration-200 ${
                    isCurrent
                      ? 'text-[#5B3FD0] font-bold'
                      : isCompleted
                      ? 'text-[#5B3FD0]/80 font-medium'
                      : 'text-[#707070]'
                  }`}
                >
                  {name}
                </span>
                {index < STEP_NAMES.length - 1 && (
                  <span className="text-gray-300">·</span>
                )}
              </span>
            );
          })}
        </div>
      </div>

      {/* Thin Progress Track */}
      <div className="h-1.5 w-full bg-gray-200/80 rounded-full overflow-hidden">
        <div
          className="h-full bg-[#5B3FD0] rounded-full transition-all duration-300 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
